import script from "./loans.vue?vue&type=script&setup=true&lang=js"
export * from "./loans.vue?vue&type=script&setup=true&lang=js"

import "./loans.vue?vue&type=style&index=0&id=0145d1a3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0145d1a3"]])

export default __exports__